import type BpmnFactory from 'bpmn-js/lib/features/modeling/BpmnFactory';

export const createElement = (
    factory: BpmnFactory,
    elementType: string,
    properties: Record<string, any>,
    parent?: Record<string, any>
) => {
    const element = factory.create(elementType, properties);

    if (parent) {
        element.$parent = parent;
    }

    return element;
};
